export class MeetingStopperViewModel
{
    opened: boolean = false;
    surveyStarted: boolean | null = null;

    show(surveyStarted: boolean)
    {
        this.surveyStarted = surveyStarted;
        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.surveyStarted = null;
    }
}